export const TIMED_OUT = 'timed-out';

export const settlesWithin = async <T>(
  promise: Promise<T>,
  ms: number,
  onTimeout?: () => void,
): Promise<T | typeof TIMED_OUT> => {
  let timer: ReturnType<typeof setTimeout> | undefined;
  try {
    const timeout = new Promise<typeof TIMED_OUT>(resolve => {
      timer = setTimeout(() => {
        resolve(TIMED_OUT);
        onTimeout?.();
      }, ms);
    });
    return await Promise.race([promise, timeout]);
  } finally {
    if (timer) clearTimeout(timer);
  }
};
